import React, { useState } from 'react'

import { useAuth } from '@/hooks/useAuth'

export const EntraLoginButton: React.FC = () => {
  const { loginWithEntra } = useAuth()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleClick = async () => {
    setIsLoading(true)
    setError(null)
    try {
      await loginWithEntra()
    } catch (err) {
      // Extraer el mensaje: puede venir del Error.message (MSAL) o del body de la API (Axios)
      const msalMsg = err instanceof Error ? err.message : ''
      const axiosErr = err as {
        response?: { status?: number; data?: { errors?: { message?: string }[]; detail?: string } }
      }
      const apiDetail: string =
        axiosErr?.response?.data?.errors?.[0]?.message || axiosErr?.response?.data?.detail || ''
      const fullMsg = (msalMsg + ' ' + apiDetail).toLowerCase()

      if (fullMsg.includes('popup_window_error') || fullMsg.includes('popupblocked')) {
        setError(
          'El navegador bloqueó la ventana emergente. Habilitá los popups para este sitio e intentá de nuevo.'
        )
      } else if (fullMsg.includes('user_cancelled')) {
        // El usuario cerró el popup — no es un error real
      } else if (
        fullMsg.includes('no existe una cuenta local') ||
        fullMsg.includes('contacte al administrador') ||
        axiosErr?.response?.status === 403
      ) {
        setError(
          'Tu cuenta de Microsoft no está registrada en la plataforma. Contactá al administrador para solicitar acceso.'
        )
      } else {
        setError('No se pudo iniciar sesión con Microsoft. Intentá de nuevo.')
      }
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="w-full">
      {error && <p className="mb-2 text-sm text-red-600 text-center">{error}</p>}
      <button
        type="button"
        onClick={handleClick}
        disabled={isLoading}
        className="w-full flex items-center justify-center gap-3 rounded-md border border-gray-300 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 transition-colors"
      >
        {isLoading ? (
          <svg
            className="h-5 w-5 animate-spin text-gray-500"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
            />
          </svg>
        ) : (
          <MicrosoftLogo />
        )}
        {isLoading ? 'Conectando...' : 'Iniciar sesión con Microsoft'}
      </button>
    </div>
  )
}

const MicrosoftLogo: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 21 21"
    aria-hidden="true"
  >
    <rect x="1" y="1" width="9" height="9" fill="#f25022" />
    <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
    <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
    <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
  </svg>
)
